import { defineMessages, IntlShape } from "react-intl";

import ParticipantStatus from "@mapmycustomers/shared/enum/ParticipantStatus";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [ParticipantStatus.MAYBE]: {
    id: "participantStatus.maybe",
    defaultMessage: "Maybe",
    description: "Participant status label for maybe",
  },
  [ParticipantStatus.NO]: {
    id: "participantStatus.denied",
    defaultMessage: "Denied",
    description: "Participant status label for denied",
  },
  [ParticipantStatus.NOREPLY]: {
    id: "participantStatus.notAccepted",
    defaultMessage: "Not accepted",
    description: "Participant status label for not accepted",
  },
  [ParticipantStatus.YES]: {
    id: "participantStatus.accepted",
    defaultMessage: "Accepted",
    description: "Participant status label for accepted",
  },
});

const getParticipantStatusDisplayName = (intl: IntlShape, participantStatus: ParticipantStatus) =>
  getDisplayName(intl, messages, participantStatus, "ParticipantStatus");

export default getParticipantStatusDisplayName;
